import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/inventory',
  component: layout,
  meta: {
    funcID: 'F0012',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'materialBatch',
      name: `${pre}materialBatch`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001201',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/materialBatch'),
    },
    {
      path: 'purchaseOrder',
      name: `${pre}purchaseOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001202',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/purchaseOrder'),
    },
    {
      path: 'purchaseStockIn',
      name: `${pre}purchaseStockIn`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001203',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/purchaseStockIn'),
    },
    {
      path: 'outsourcingOrders',
      name: `${pre}outsourcingOrders`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001207',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/outsourcingOrders'),
    },
    {
      path: 'outsourcingStockIn',
      name: `${pre}outsourcingStockIn`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001208',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/outsourcingStockIn'),
    },
    {
      path: 'outsourcingStockOut',
      name: `${pre}outsourcingStockOut`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001209',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/outsourcingStockOut'),
    },
    {
      path: 'salesStockIn',
      name: `${pre}salesStockIn`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001210',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/salesStockIn'),
    },
    {
      path: 'salesStockOut',
      name: `${pre}salesStockOut`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001211',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/salesStockOut'),
    },
    {
      path: 'finishedInbound',
      name: `${pre}finishedInbound`,
      meta: {
        ...meta,
        head: { back: false },
        title: '成品入库单',
        funcID: 'F001204',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/finishedInbound'),
    },
    {
      path: 'otherInbound',
      name: `${pre}otherInbound`,
      meta: {
        ...meta,
        head: { back: false },
        title: '其他入库单',
        funcID: 'F001205',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/otherInbound'),
    },
    {
      path: 'otherOutbound',
      name: `${pre}otherOutbound`,
      meta: {
        ...meta,
        head: { back: false },
        title: '其他出库单',
        funcID: 'F001206',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/otherOutbound'),
    },
    {
      path: 'warehouseTransfer',
      name: `${pre}warehouseTransfer`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001212',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inventory/warehouseTransfer'),
    },
  ])('inventory-'),
}
